/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react';
import styles from './ccf-unified-inbox.module.scss';
import CcfInboxCards from '../ccf-inbox-cards/ccf-inbox-cards';
import {
  getContacts,
  selectInboxCollapsedState,
  updateInboxCollapsed,
  setIsDocked,
  selectCallType,
  activeContactSelector,
  setInboxSorting,
  useSimulatorToInsertContact,
  getPersonalConnectionCount,
  setPersonalConnectionCount,
  getWorkingOBContacts,
  getIsHungUp,
  getIsRejected,
  addToRejectedOBContacts,
  getRejectedOBContacts,
} from '../ccf-inbox.slice';
import { useDispatch, useSelector } from 'react-redux';
import { Contact } from '../model/contact';
import {
  CcfAssignmentCollapseIcon,
  CcfTypography,
  CcfOutboundAssignmentIcon,
  CcfInboundAssignmentIcon,
  useTranslator,
  CcfBox,
  CcfSnackBar,
  CcfAlert,
  CcfTooltip,
  CcfSortingIcon,
  CcfButton,
  CcfSortByIcon,
  CcfUpArrowIcon,
  CcfNoAssignmentIcon,
} from '@nice-ccf/ui-controls';
import { TransitionGroup } from 'react-transition-group';
import {
  getSelectedMenuName,
  globalActions,
} from '../../../lib/global.app.slice';
import { updateAppSpaceTab } from '../../ccf-inbox/ccf-inbox.slice';
import { Navigation } from '../../../enums/navigation-menus';
import {
  CcfCallConference,
  CcfContactControlPanel,
  getApplicationDirection,
  interactionSliceActions,
  setSelectedContact,
  CcfFetchInboundOutboundPopover,
  updateContactInteraction,
  getActiveInteractionID,
  selectcurrentStatus,
} from '@nice-ccf/ui-components';
import { Direction, Popover, Select, MenuItem, Slide } from '@mui/material';
import { MediaType } from '@nice-ccf/core-sdk';
import { AppSpace } from '../../../enums/app-space-tabs';
import { getInteractionData } from '../../ccf-interaction-workspace/ccf-interaction-mock-data';
import { useHistory } from 'react-router';
import { CcfLiveCopilotAudio } from './ccf-live-copilot-audio';
import CcfLiveCopilotPOVAudio from './ccf-live-copilot-pov-audio';
import CcfCopilotHca from './ccf-copilot-hca';

/* eslint-disable-next-line */
export interface CcfUnifiedInboxProps {}
/**
 * Component to display assignment box on UI
 * @example - <CcfUnifiedInbox/>
 */
export function CcfUnifiedInbox(props?: CcfUnifiedInboxProps) {
  const appDirection: Direction = useSelector(getApplicationDirection);
  const contacts: Contact[] = useSelector(getContacts);
  const isInboxCollpased: boolean = useSelector(selectInboxCollapsedState);
  const selectedMenuName = useSelector(getSelectedMenuName);
  const callType = useSelector(selectCallType);
  const activeContact = useSelector(activeContactSelector);
  const activeInteractionID = useSelector(getActiveInteractionID);
  const [showReqInteractionToast, setshowReqInteractionToast] = useState(false);
  const dispatch = useDispatch();
  const [translate] = useTranslator();
  //localization rtl and ltr specific classes
  const slideDirection = appDirection === 'rtl' ? 'right' : 'left';
  const { setSelectedMenu } = globalActions;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openSortingPopover, setOpenSortingPopover] = useState(false);
  const [sortBy, setSortBy] = useState('Created Date');
  const [sortByOrder, setSortByOrder] = useState('desc');

  const agentState = useSelector(selectcurrentStatus);
  const outboundContactCount = useSelector(getPersonalConnectionCount);
  const workingOBContacts = useSelector(getWorkingOBContacts);
  const isHungUp = useSelector(getIsHungUp);
  const isRejected = useSelector(getIsRejected);
  const rejectedOBContacts = useSelector(getRejectedOBContacts);

  useEffect(() => {
    const { id, channel, contactStatus, botTranscript, copilotAssist } =
      activeContact || {};
    if (!activeContact && contacts.length > 0) {
      setTimeout(() => {
        dispatch(setSelectedContact(contacts[0]));
        // dispatch(updateAppSpaceTab({ tab: AppSpace.CUSTOMERCARD }));
      }, 850);
    } else if (contacts.length === 0) {
      dispatch(setSelectedMenu({ name: Navigation.CONTACTHISTORY }));
    }
    // if (contactStatus === 'active' || contactStatus === 'open') {
    //    dispatch(setInteractionForActiveContact({id : activeContact.id}));
    // }
    if (
      (contactStatus === 'new' || contactStatus === 'open') &&
      !activeInteractionID
    ) {
      if (botTranscript) {
        const interactionWithBotTranscript = {
          id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
          channelID: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
          realExternalPlatformId: 'chat',
          name: 'This is my testing chat',
          hasAbilityToQuoteMessage: true,
          hasAbilityToLike: false,
          hasAbilityToShare: false,
          isPrivate: true,
          hasAbilityToSendFiles: true,
          nicknameOnExternalPlatform: '',
          originalTweetContent: {},
          agentReply: [
            {
              id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
              idOnExternalPlatform: '13649193210471634682',
              threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
              messageContent: {
                type: 'TEXT',
                payload: {
                  text: '',
                },
              },
              reactionStatistics: {
                likes: 1250,
                shares: 764,
                isLikedByChannel: false,
                isSharedByChannel: false,
              },
              createdAt: new Date().toUTCString(),
              direction: 'string',
              authorUser: {
                id: 242578,
                incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
                emailAddress: 'customer.service@delta.com',
                loginUsername: '@JPatrick',
                firstName: 'Patrick',
                surname: 'Jordan',
                isBotUser: false,
                isSurveyUser: false,
              },
              authorEndUserIdentity: null,
              isDeletedOnExternalPlatform: false,
              isHiddenOnExternalPlatform: false,
              isRead: false,
              attachments: [],
              tags: [
                {
                  id: 123,
                  title: '',
                  color: '',
                },
              ],
              sentiment: 'neutral',
              contentRemoved: null,
              authorNameRemoved: null,
              replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
              readAt: {
                date: '2021-05-10 07:03:02.000000',
                timezone_type: 1,
                timezone: '+00:00',
              },
              messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
              isOwn: true,
            },
          ],
          otherReplies: [],
          isHistoryEmailContent: false,
        };
        if (activeContact?.botTranscriptData) {
          for (const [
            index,
            value,
          ] of activeContact.botTranscriptData.entries()) {
            const interval = 60000 * (index + 1) + 1520 * (index + 1);
            const botTranscriptMsg: any = {
              id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
              idOnExternalPlatform: '13649193210471634682',
              threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
              messageContent: {
                type: 'TEXT',
                payload: {
                  text: value.message,
                },
              },
              reactionStatistics: {
                likes: 1250,
                shares: 764,
                isLikedByChannel: false,
                isSharedByChannel: false,
              },
              createdAt: new Date(
                new Date().getTime() - (600000 - interval)
              ).toUTCString(),
              direction: 'string',
              authorUser: {
                id: 242578,
                incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
                emailAddress:
                  value.messageFrom === 'bot'
                    ? 'autopilot@nice.com'
                    : activeContact?.customer?.emailId,
                loginUsername:
                  value.messageFrom === 'bot'
                    ? '@AutoPilot'
                    : activeContact?.customer?.emailId,
                firstName:
                  value.messageFrom === 'bot'
                    ? 'Auto'
                    : activeContact?.customer?.firstName,
                surname:
                  value.messageFrom === 'bot'
                    ? 'Pilot'
                    : activeContact?.customer?.lastName,
                isBotUser: value.messageFrom === 'bot' ? true : false,
                isSurveyUser: false,
              },
              authorEndUserIdentity: null,
              isDeletedOnExternalPlatform: false,
              isHiddenOnExternalPlatform: false,
              isRead: false,
              attachments: [],
              tags: [
                {
                  id: 123,
                  title: '',
                  color: '',
                },
              ],
              sentiment: 'neutral',
              contentRemoved: null,
              authorNameRemoved: null,
              replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
              readAt: {
                date: '2021-05-10 07:03:02.000000',
                timezone_type: 1,
                timezone: '+00:00',
              },
              messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
              isOwn: true,
            };
            interactionWithBotTranscript?.agentReply.push(botTranscriptMsg);
          }
          const botTranscriptMsg: any = {
            id: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
            idOnExternalPlatform: '13649193210471634682',
            threadId: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
            messageContent: {
              type: 'DIVIDER',
              payload: {
                text: 'this is to render end of transcript',
              },
            },
            reactionStatistics: {
              likes: 1250,
              shares: 764,
              isLikedByChannel: false,
              isSharedByChannel: false,
            },
            createdAt: new Date(new Date().getTime()).toUTCString(),
            direction: 'string',
            authorUser: {
              id: 242578,
              incontactId: '11eb0e0e-3d8f-3ae0-a837-0242ac110343',
              emailAddress: activeContact?.customer?.emailId,
              loginUsername: activeContact?.customer?.emailId,
              firstName: activeContact?.customer?.firstName,
              surname: activeContact?.customer?.lastName,
              isBotUser: false,
              isSurveyUser: false,
            },
            authorEndUserIdentity: null,
            isDeletedOnExternalPlatform: false,
            isHiddenOnExternalPlatform: false,
            isRead: false,
            attachments: [],
            tags: [
              {
                id: 123,
                title: '',
                color: '',
              },
            ],
            sentiment: 'neutral',
            contentRemoved: null,
            authorNameRemoved: null,
            replyToMessage: 'chat_b8f6e4f2_a8af_4607_b7e8_e3b5d748b09d',
            readAt: {
              date: '2021-05-10 07:03:02.000000',
              timezone_type: 1,
              timezone: '+00:00',
            },
            messageId: '14e0e6fa-0c93-4d02-909e-f9c9131ad954',
            isOwn: true,
          };
          interactionWithBotTranscript?.agentReply.push(botTranscriptMsg);
        }

        dispatch(
          updateContactInteraction({
            id,
            interaction: interactionWithBotTranscript,
          })
        );
      } else {
        dispatch(
          updateContactInteraction({
            id,
            interaction: getInteractionData(channel, copilotAssist),
          })
        );
      }
    }
  }, [activeContact]);

  useEffect(() => {
    dispatch(setPersonalConnectionCount(0));
    dispatch(addToRejectedOBContacts([]));
    // eslint-disable-next-line react-hooks/rules-of-hooks
    if (
      agentState === 'Working-OB' &&
      outboundContactCount === 0 &&
      contacts.length === 0
    ) {
      dispatch(
        useSimulatorToInsertContact(workingOBContacts[outboundContactCount])
      );
      dispatch(updateAppSpaceTab({ tab: AppSpace.CUSTOMERCARD }));
      dispatch(setPersonalConnectionCount(outboundContactCount + 1));
    }
  }, [agentState]);

  useEffect(() => {
    const rejectedOBContactsCopy = Object.assign([], rejectedOBContacts);
    if (
      agentState === 'Working-OB' &&
      activeContact?.isWorkingOB &&
      (isHungUp || isRejected) &&
      outboundContactCount <= 5
    ) {
      if (isRejected) {
        rejectedOBContactsCopy.push(
          workingOBContacts[outboundContactCount - 1]
        );
        dispatch(addToRejectedOBContacts(rejectedOBContactsCopy));
      }
      if (outboundContactCount <= 4 && (isHungUp || isRejected)) {
        setTimeout(() => {
          dispatch(
            useSimulatorToInsertContact(workingOBContacts[outboundContactCount])
          );
        }, 3000);
      }
      const personalConnectioncountcopy = outboundContactCount + 1;
      dispatch(setPersonalConnectionCount(personalConnectioncountcopy));
    }
  }, [isHungUp, isRejected]);

  useEffect(() => {
    if (
      agentState === 'Working-OB' &&
      outboundContactCount > 5 &&
      rejectedOBContacts.length > 0
    ) {
      setTimeout(() => {
        if ((isHungUp || isRejected) && contacts.length === 0) {
          const rejectedOBContactsCopy2 = Object.assign([], rejectedOBContacts);
          dispatch(useSimulatorToInsertContact(rejectedOBContactsCopy2[0]));
          const removeRejectedObject: Contact[] =
            rejectedOBContactsCopy2.splice(0, 1);
          dispatch(addToRejectedOBContacts(rejectedOBContactsCopy2));
        }

        const personalConnectioncountcopy = outboundContactCount + 1;
        dispatch(setPersonalConnectionCount(personalConnectioncountcopy));
      }, 3000);
    }
  }, [outboundContactCount]);

  /**
   * Method to toggle Collapse assignment box
   * @example toggleCollapse(true);
   */
  const toggleCollapse = (updatedCollapsedState: boolean) => {
    if (activeContact && activeContact.isDocked === true) {
      dispatch(setIsDocked({ id: activeContact.id, isDocked: false }));
    }
    dispatch(updateInboxCollapsed(updatedCollapsedState));
  };

  /**
   * Method to open Sorting Inbox popover
   * @example sortingInboxPopoverHandler();
   */
  const sortingInboxPopoverHandler = (event: any) => {
    setAnchorEl(event.currentTarget);
    setOpenSortingPopover(true);
  };

  /**
   * @example handleClose()
   */
  const handleClose = () => {
    setAnchorEl(null);
    setOpenSortingPopover(false);
  };

  /**
   * @example sortByOrderHandler()
   */
  const sortByOrderHandler = () => {
    sortByOrder === 'desc' ? setSortByOrder('asc') : setSortByOrder('desc');
  };

  /**
   * @example saveSortingHandler()
   */
  const saveSortingHandler = () => {
    dispatch(setInboxSorting({ sortBy: sortBy, sortByOrder: sortByOrder }));
    handleClose();
  };

  /**
   * Function is called on clicking Intitate outbound.
   * @example -outboundCallInitiate()
   */
  const outboundCallInitiate = () => {
    dispatch(updateAppSpaceTab({ tab: AppSpace.DIRECTORY }));
    //history.push('/dashboard/' + Navigation.ASSIGNMENT);
    if (selectedMenuName !== Navigation.ASSIGNMENT)
      dispatch(setSelectedMenu({ name: Navigation.INTERACTION }));
  };

  /**
   * Function is called on clicking fetch interaction. It will fetch for new interactions and add in assignment section
   * @example fetchInteraction()
   */
  const fetchInteraction = () => {
    dispatch(setSelectedMenu({ name: Navigation.INTERACTION }));
    //history.push('/dashboard/' + Navigation.ASSIGNMENT);
    setshowReqInteractionToast(true);
  };

  /**
   * Function to close request interaction toast
   * @example handleReqInteractionClose()
   */
  const handleReqInteractionClose = () => {
    setshowReqInteractionToast(false);
  };

  return (
    <section className={styles.container}>
      <div className={styles.assignementContainer}>
        <div
          className={`${isInboxCollpased ? 'collapsedInbox' : 'expandedInbox'}`}
        >
          {!isInboxCollpased ? (
            <div className={'assignmentHeaderExpanded'}>
              <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                {/* <CcfTypography
                  variant="inherit"
                  translationKey="assignments"
                  className="assignmentLabel"
                />
                <CcfTooltip title={translate('requestInteraction')} arrow>
                  <div
                    className="inboundOutbound"
                    onClick={fetchInteraction}
                    id="agent_activeContact_inbox_requestInteractionIcon"
                  >
                    <CcfInboundAssignmentIcon
                      className="inboundOutboundIcons"
                      viewBox="-3 -2 24 24"
                    />
                  </div>
                </CcfTooltip> */}
                <CcfTooltip title={translate('newOutbound')} arrow>
                  <div
                    onClick={outboundCallInitiate}
                    id="agent_activeContact_inbox_newOutboundIcon"
                  >
                    <CcfOutboundAssignmentIcon
                      className="inboundOutboundIcons"
                      viewBox="-3 -2 24 24"
                    />
                  </div>
                </CcfTooltip>
              </div>
              {/* <CcfTooltip title={translate('sort')} arrow>
                <div>
                  <CcfSortingIcon
                    cursor={'pointer'}
                    onClick={(e) => sortingInboxPopoverHandler(e)}
                    id="agent_activeContact_inbox_sortingIcon"
                  ></CcfSortingIcon>
                </div>
              </CcfTooltip> */}
              <CcfTooltip title={translate('collapse')} arrow>
                <div>
                  <CcfAssignmentCollapseIcon
                    className="expandIcon"
                    onClick={() => toggleCollapse(true)}
                    id="agent_activeContact_inbox_assignmentCollapseIcon"
                  ></CcfAssignmentCollapseIcon>
                </div>
              </CcfTooltip>
            </div>
          ) : (
            <div className={'assignmentHeaderCollapsed'}>
              {/* <CcfFetchInboundOutboundPopover
                initiateOutbound={outboundCallInitiate}
                fetchInteraction={fetchInteraction}
              /> */}
              <CcfTooltip title={translate('newOutbound')} arrow>
                <div
                  onClick={outboundCallInitiate}
                  id="agent_activeContact_inbox_newOutboundIcon"
                >
                  <CcfOutboundAssignmentIcon
                    className="inboundOutboundIcons"
                    viewBox="-3 -2 24 24"
                  />
                </div>
              </CcfTooltip>
              <CcfTooltip title={translate('expand')} arrow>
                <div>
                  <CcfAssignmentCollapseIcon
                    className="collapseIcon"
                    onClick={() => toggleCollapse(false)}
                  ></CcfAssignmentCollapseIcon>
                </div>
              </CcfTooltip>
            </div>
          )}
          <CcfBox>
            <CcfSnackBar
              open={showReqInteractionToast}
              autoHideDuration={2000}
              onClose={() => handleReqInteractionClose()}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
              <div>
                <CcfAlert
                  closeAlert={handleReqInteractionClose}
                  severity="success"
                >
                  {translate('requestingInteraction')}
                </CcfAlert>
              </div>
            </CcfSnackBar>
          </CcfBox>
          <div
            className={`${'cardsConatiner'} ${
              isInboxCollpased
                ? 'cardContainerCollpased'
                : 'cardContainerExpanded'
            }`}
          >
            {contacts?.length !== 0 ? (
              <>
                <TransitionGroup>
                  {contacts?.map((cardItem, index: number) => (
                    <Slide
                      key={cardItem.id}
                      direction={slideDirection}
                      timeout={1000}
                    >
                      <div id="agent_activeContact_inbox">
                        <CcfInboxCards
                          contact={cardItem}
                          callType={callType}
                        ></CcfInboxCards>{' '}
                      </div>
                    </Slide>
                  ))}
                </TransitionGroup>
                {activeContact?.liveVoice === 'Yes' ? (
                  <CcfCopilotHca />
                ) : (
                  <CcfLiveCopilotAudio />
                )}
              </>
            ) : (
              <div
                className={`${
                  isInboxCollpased
                    ? 'noAssignmentDivCollapsed'
                    : 'noAssignmentDivExpanded'
                }`}
              >
                <CcfNoAssignmentIcon />
                {!isInboxCollpased && (
                  <CcfTypography
                    variant="inherit"
                    className={`${'noAssignmentTextCommon'} ${
                      isInboxCollpased
                        ? 'noAssignmentCollpased'
                        : 'noAssignmentExpanded'
                    }`}
                  >
                    {translate('noAssignments')}
                  </CcfTypography>
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.assignementContainer}>
          {callType !== 'conference' &&
            selectedMenuName === Navigation.ASSIGNMENT &&
            activeContact &&
            activeContact.isDocked === false && (
              <div className="controlPanelContainer">
                <CcfContactControlPanel
                  iconArr={activeContact.contactButtons}
                  showHeader={true}
                  showSubHeading={
                    activeContact.media === MediaType.VOICE ? true : false
                  }
                  headerText={`${[
                    activeContact?.customer?.firstName,
                    activeContact?.customer?.middleName,
                    activeContact?.customer?.lastName,
                  ]
                    .filter(Boolean)
                    .join(' ')}`}
                  subHeading1={activeContact.customer.phoneNo}
                  subHeading2="#439-Z3FM-5S23"
                  contact={activeContact}
                ></CcfContactControlPanel>
              </div>
            )}
          {callType === 'conference' && (
            <CcfCallConference
              className={styles.callConferenceContainer}
              domNodeId={
                activeContact?.isDocked ? 'ccf-active-call' : undefined
              }
            />
          )}
        </div>
      </div>
      {openSortingPopover && (
        <Popover
          id={'sorting-inbox-popover'}
          open={Boolean(anchorEl)}
          keepMounted
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          style={{ margin: '10px 0px 0px 35px' }}
        >
          <CcfBox className={styles.sortingPopoverContainer}>
            <CcfBox className={styles.headerSection}>
              <CcfTypography className={styles.headerTitle}>
                {`${translate('sortBy')} :`}
              </CcfTypography>
              <CcfSortByIcon
                onClick={sortByOrderHandler}
                className={`${styles.sortByIcon} ${
                  sortByOrder === 'desc' ? styles.sortByDesc : styles.sortByAsc
                }`}
              />
            </CcfBox>
            <CcfBox>
              <Select
                displayEmpty
                name="sortBy"
                variant="outlined"
                className={styles.dropdown}
                value={sortBy}
                SelectDisplayProps={{
                  style: { fontSize: '13px', color: '#333333' },
                }}
                sx={{
                  '&& fieldset': {
                    border: '1px solid #c4c4c4',
                  },
                }}
                IconComponent={() => (
                  <CcfUpArrowIcon className={styles.arrowIconForDropdown} />
                )}
                onChange={(e: any) => {
                  setSortBy((e?.target as HTMLSelectElement).value);
                }}
              >
                <MenuItem value={'Created Date'}>
                  {translate('createdDate')}
                </MenuItem>
                <MenuItem value={'Last Visited'}>
                  {translate('lastVisited')}
                </MenuItem>
              </Select>
            </CcfBox>
            <CcfBox className={styles.BtnContainer}>
              <CcfButton className={`${styles.btn} ${styles.CancelButton}`}>
                <CcfTypography
                  className={`${styles.btnText} ${styles.txtCancel}`}
                  onClick={handleClose}
                >
                  {translate('cancel')}
                </CcfTypography>
              </CcfButton>
              <CcfButton
                primary
                className={`${styles.btn} ${styles.saveButton}`}
              >
                <CcfTypography
                  className={`${styles.btnText} ${styles.txtSave}`}
                  onClick={saveSortingHandler}
                >
                  {translate('sort')}
                </CcfTypography>
              </CcfButton>
            </CcfBox>
          </CcfBox>
        </Popover>
      )}
    </section>
  );
}

export default CcfUnifiedInbox;
